module.exports = __webpack_public_path__ + "pc/img/img_award2022_04.0bd55216.webp";